import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
import { Helmet } from "react-helmet";
import BookingModal from "@/components/booking/BookingModal";

const BookingTest = () => {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Test Réservation - Bio Beauté Zen</title>
      </Helmet>
      
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-bbz-cream via-bbz-beige/20 to-bbz-pink/10">
        <div className="text-center space-y-6 p-8">
          <div className="space-y-2">
            <h1 className="font-playfair text-3xl md:text-4xl font-semibold text-bbz-text">
              Test du système de réservation
            </h1>
            <p className="text-bbz-text/70 text-sm md:text-base">
              Page de test non indexée
            </p>
          </div>
          
          <Button
            size="lg"
            onClick={() => setIsBookingModalOpen(true)}
            className="gap-2 shadow-lg hover:shadow-xl transition-all"
          >
            <Calendar className="w-5 h-5" />
            Tester la réservation
          </Button>
        </div>
      </div>

      <BookingModal
        isOpen={isBookingModalOpen}
        onClose={() => setIsBookingModalOpen(false)}
      />
    </>
  );
};

export default BookingTest;
